import { render } from "./app-block-ui.vue?vue&type=template&id=292d1e05&ts=true"
import script from "./app-block-ui.vue?vue&type=script&lang=ts"
export * from "./app-block-ui.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__